import '../styles/main.scss';

import Vue from 'vue';

import layouts from './helpers/layouts';
import createPoints from './helpers/createPoints';
import animate from './helpers/animate';
import colors from './helpers/colors';

// Importing these so webpack will include them in the bundle
import './components/navigation/navigation';
import './components/filters/filters';
import './components/subscribe/subscribe';
import './components/credits/credits';

// Import the main app template
import template from './app.html';

// Debounce reanimating on resize
let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(animate, 200);
});

// Create the regl instance
const regl = require('regl')({
  container: '#regl',
  pixelRatio: 2,
});

// Setup Vue data
const data = {
  showMobileWarning: true,

  groups: [],
  points: [],

  // App state
  loading: true,
  animating: true,
  auto: false,
  autoInterval: null,
  // For development, add hash option
  // to quickly switch between slides
  layoutIndex: +window.location.hash.split('').pop() || 0,
  layouts,
  filter: [null, null],

  slideText: [
    null,
    `Each dot represents a darknet site in the DarkOwl index.`,
    `What if we could sort these to look at their different traits?`,
    `Select a source, language, or classification filter on the left to show sites which <span style="color: ${ colors.green.hex }">match the trait</span> and which <span style="color: ${ colors.grey.hex }">don't</span>. <span class="hide-mobile">Here's a <a href="https://www.darkowl.com/darknet-glossary" target="_blank" rel="noopener">glossary of terms</a>.</span>`,
    `Now select two filters to compare size and see the number of sites that <span style="color: ${ colors.green.hex }">match both filters</span>. <span class="hide-mobile">Here's a <a href="https://www.darkowl.com/darknet-glossary" target="_blank" rel="noopener">glossary of terms</a>.</span>`,
    // `By grouping sites by exact combinations of source, laguages, and topics, we begin to see patterns emerge.`,
    // `While <span style="color: ${ colors.green.hex }">Tor</span> is still the most well-known darknet, we’re seeing new darknets grow in popularity, such as <span style="color: ${ colors.pink.hex }">ZeroNet</span> and <span style="color: ${ colors.orange.hex }">I2P</span>.`,
    `The darknet is vastly faceted, in myriad languages and classifications, and constantly evolving. What will it look like tomorrow?`,
    null,
  ],

  // Stuff regl needs
  pointWidth: 4,
  duration: 1500,
  // These will be computed
  // when we know how many points
  numPoints: 0,
  delayByIndex: 0,
  maxDuration: 0,
};

// Create Vue app
const app = new Vue({
  el: '#app',
  template,
  data,
  created: function () {
    // Load/process the JSON data and
    // kickoff the animation
    fetch('./assets/data.json')
      .then(res => res.json())
      .then(createPoints)
      .then(animate);
  },

  mounted: function() {
    window.addEventListener('keyup', event => {
      // Right arrow moves forward
      if (event.key === 'ArrowRight') {
        this.turnOffAutoSlide();
        this.onChangeSlide(true);
      }

      // Left arrow moves backward
      else if (event.key === 'ArrowLeft') {
        this.turnOffAutoSlide();
        this.onChangeSlide(false);
      }

      // Ctrl + a toggles auto-slide mode
      else if (event.key === 'a') {
        this.auto = !this.auto;
        if (this.auto) {
          this.onChangeSlide(true);
          // Stash interval for later removal
          this.autoInterval = setInterval(() => {
            this.onChangeSlide(true);
          }, 6000);
        } else {
          this.turnOffAutoSlide()
        }
      }
    });

    window.addEventListener('click', () => {
      if (this.auto) {
        this.turnOffAutoSlide();
      }
    });
  },

  methods: {
    turnOffAutoSlide: function() {
      this.auto = false;
      clearInterval(this.autoInterval);
    },

    onChangeSlide: function (increment) {
      if (this.animating) {
        return;
      } else {
        this.animating = true;
      }

      if (increment) {
        this.layoutIndex = (this.layoutIndex + 1) % this.layouts.length;
      } else {
        this.layoutIndex = Math.max(this.layoutIndex - 1, 0);
      }

      if (this.layoutIndex === 3) this.filter = ['english', null];
      if (this.layoutIndex === 4) this.filter = ['counterfeit', 'cryptocurrency'];

      animate();
    },

    onChangeFilter: function (filter) {
      if (this.animating || filter === this.filter[0]) {
        return;
      } else {
        this.animating = true;
      }

      this.filter[1] = this.filter[0];
      this.filter[0] = filter;
      animate();
    }
  },
});

export { app, regl };



// WEBPACK FOOTER //
// ./src/app.js